/**
 * Navigation Fragment
 *
 * Common pattern for navigation items and menus used across multiple queries.
 */

import { imageFields } from './image'
import { linkFields } from './link'

/**
 * Field projection for navigation items
 * Can be interpolated into navigation queries
 */
export const navigationFields = `
  _id,
  _type,
  ...select(
    _type == "navigationItem" => {
      title,
      url
    },
    _type == "navigationMenu" => {
      title,
      description,
      "link": link->{
        ${linkFields}
      },
      image{
        ${imageFields}
      },
      "items": items[]->{
        _id,
        title,
        url
      }
    }
  )
`
